import React from 'react';
import { TableCell } from '@mui/material';

import type { Column } from 'api/shared/models';

import CurrentTableContext from 'components/shared/CustomTable/context';
import { getStylesTableHeaderByColumn } from 'components/shared/CustomTable/helpers';

import { arrayValidation } from 'utils/array';

import CustomTableCellBody from '../CustomTableCellBody';

interface Props {
  column: Column;
  index: number;
}

const CustomTableCell = ({ column, index }: Props) => {
  const {
    addStylesTableHeader,
    sxHeaderTableCell,
    columns,
    isLoading,
    rows,
    handleRequestSort,
  } = React.useContext(CurrentTableContext);

  const createSortHandler = (property: string) => (event: any) => {
    handleRequestSort && handleRequestSort(event, property);
  };

  const handleStylesTableHeaderByColumn = () => {
    if (!addStylesTableHeader) return {};
    return getStylesTableHeaderByColumn({
      index,
      column,
      columns,
      noRenderFixedColumn: isLoading || !arrayValidation(rows),
    });
  };

  return (
    <TableCell
      sx={sxHeaderTableCell}
      colSpan={column.colSpan}
      align={column.align || 'left'}
      width={column.width || 'auto'}
      style={handleStylesTableHeaderByColumn()}
    >
      <CustomTableCellBody
        column={column}
        createSortHandler={createSortHandler}
      />
    </TableCell>
  );
};

export default CustomTableCell;
